import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import Select from "react-select";
import ship from "../../../images/ship.jpeg";
import cargo from "../../../images/cargo.png";
import crane from '../../../images/crane img.png'
import Pumps from '../../../images/water pump.png'
import ME from '../../../images/ME.png'
import cabin from '../../../images/cabin.png'
import Nav from '../../../images/all ship images/Compass.png'
import gen from '../../../images/Generator.png'
import lube from '../../../images/lube.png'
import Footer from "../../Footer";
import AdminNav from "./AdminNav";
import Usernav from "../../UserHome/Usernav";
import axios from "axios";
import config from "../../../function/config";
import NewAdminNav from "./NewAdminNav";
import NewFooter from "../../NewFooter";

export default function AdminSupplyEq() {
   const [user,setUser] = useState(null)
    const token = localStorage.getItem('token')
     const navigate = useNavigate('')
    useEffect(() => {
        async function fetchdata() {
          try {
            const res2 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/viewusers`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Token ${token}`,
                },
              }
            );
            console.log("API response:", res2.data);
            if (res2.data.status === 200) {
              console.log("User:",res2);
              setUser(res2.data.data);
            } else {
              console.log(res2);
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [ token]);

      useEffect(() => {
      if (!token) {
        navigate('/login'); // login page
      }
    }, [token, navigate]);

  return (
    <div>
      <div className="">
         <NewAdminNav />

        <section className="bg-[#9ccee2] m-auto lg:px-5 2xl:px-10 xl:px-5 py-[50px] px-[40px]   xm:py-[20px]">
  {/* <h1 className="text-center text-white font-bold text-2xl">Supply Equipments</h1> */}

  <div className="main mt-5 grid grid-cols-5 L:grid-cols-none L:flex L:flex-wrap   m-auto lg:justify-between  gap-12 py-5">
    {/* Deck-store */}
    <Link to={'/deck'} className="Deck-store 3xl:m-auto cursor-pointer hover:scale-105 hover:bg-gray-100 transition-all duration-300 shadow-lg bg-white rounded 3xl:w-[175px] lg:w-[265px]  w-[265px] p-3 h-[200px]">
        <div className="">
<div className="bg-gray-300 w-24 m-auto mt-2 rounded-full">
          <i className='bx bx-hard-hat  text-6xl text-[#D1A460]  flex justify-center py-3'></i>
  
</div>
<div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-gray-100  font-bold text-xl 3xl:text-[13px]  py-2 mt-10 text-center">Deck Store</h1>
  
</div>        {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
          <li>Nautical Equipment</li>
          <li>Safety Equipment</li>
          <li>Ropes & Hawsers</li>
        </ul> */}

        {/* <div className="m-auto flex justify-center">
          <button className="rounded border transition-all hover:bg-[#D1A460] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center  mt-10">
            View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right "></i>
          </button>
        </div> */}
        </div>

    </Link>

    {/* Engine-store */}
    <Link to={'/enginestore'} className="Engine-store shadow-lg 3xl:m-auto bg-white hover:bg-gray-100 cursor-pointer hover:scale-105 transition-all  rounded w-[265px] 3xl:w-[175px] lg:w-[265px]   p-3 h-[200px]">
        <div className="">
<div className="bg-gray-300 w-24 m-auto mt-2 rounded-full">
          <i className='fa-solid fa-screwdriver-wrench text-6xl text-[#D1A460] flex justify-center py-3'></i>
  
</div>        <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-10 text-center">Engine Store</h1>
  
</div>          {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
          <li>Crew Supplies</li>
          <li>Hand Tools</li>
          <li>Power Tools</li>
        </ul> */}

        {/* <div className="m-auto flex justify-center">
          <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center  mt-10">
            View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right "></i>
          </button>
        </div> */}
        </div>

    </Link>

    {/* Cabin-store */}
    <Link to={'/cabin'} className="cabin-store shadow-lg 3xl:m-auto cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all bg-white rounded w-[265px] 3xl:w-[175px] lg:w-[265px]   p-3 h-[200px]">
  <div className="">
    {/* Perfectly round background and centered image */}
    <div className="w-24 bg-gray-300 rounded-full mx-auto mt-2 flex items-center justify-center overflow-hidden">
      <img src={cabin} className="w-[170px]  object-contain" alt="Cabin Icon" />
    </div>

    <div className="bg-[#2e5575] m-auto rounded-lg mt-8">
      <h1 className="text-white font-bold text-xl 3xl:text-[13px] py-2 text-center">Cabin Store</h1>
    </div>
  </div>
</Link>


    {/* Navigation Equipments */}
    <Link to={'/navigation'} className="Navigation-equipments 3xl:m-auto cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all shadow-lg bg-white rounded w-[265px] 3xl:w-[175px] lg:w-[265px]   p-2 h-[200px]">
        <div className="">
        <div className="w-28 bg-gray-300 rounded-full mx-auto mt-3 flex items-center justify-center overflow-hidden">
         <img src={Nav} className="w-[170px]  object-contain" alt="" />

             {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
        <li>Radar Systems</li>
        <li>Magnetic Compass</li>
        <li>GPS Equipment</li>
        </ul>

        <div className="m-auto flex justify-center">
          <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center  mt-10">
            View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right "></i>
          </button>
        </div> */}
        </div>
        <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold  text-xl 3xl:text-[13px] py-2  mt-8 text-center">Navigation Equipments</h1>
  
</div>     

    </div>

    
</Link>

{/* Valve & Pipes */}
<Link to={'/valve'} className="Valve-Pipes 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all rounded w-[265px] p-3 h-[200px]">
        <div className="">
        <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><i className='fa-solid py-3 fa-faucet text-6xl text-[#D1A460] flex justify-center mt-5'></i></div>
        <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white   font-bold text-xl 3xl:text-[13px] py-2 mt-8 text-center">Valve & Pipes</h1>
  
</div>          {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
        <li>Ball Valves</li>
      <li>Gate Valves</li>
      <li>Steel Pipes & Fittings</li>
        </ul> */}

        {/* <div className="m-auto flex justify-center">
          <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center  mt-10">
            View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right "></i>
          </button>
        </div> */}
        </div>

    </Link>

    {/* Cranes */}
    <Link to={'/crane'} className="Cranes 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all rounded w-[265px] p-3 h-[200px]">
  <div className="">
    <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><img src={crane} className="w-[170px]  object-contain" alt="" /></div>
    <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-8 text-center">Cranes</h1>
  
</div>      {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
      <li>Deck Cranes</li>
      <li>Engine Room Cranes</li>
      <li>Provision Cranes</li>
    </ul> */}

    {/* <div className="m-auto flex justify-center">
      <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center mt-10">
        View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right"></i>
      </button>
    </div> */}
  </div>
</Link>

{/* Pumps */}
<Link to={'/pumps'} className="Pumps 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto rounded cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all w-[265px] p-3 h-[200px]">
  <div className="">
  <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><img src={Pumps} className="w-[170px]  object-contain" alt="" /></div>
  <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-8 text-center">Pumps</h1>
  
</div>      {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
    <li>Fresh Water Pumps</li>
  <li>Bilge Pumps</li>
  <li>Fuel Transfer Pumps</li>
    </ul>

    <div className="m-auto flex justify-center">
      <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center mt-10">
        View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right"></i>
      </button>
    </div> */}
  </div>
</Link>

{/* ME */}
<Link to={'/ME'} className="ME 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto rounded cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all w-[265px] p-3 h-[200px]">
  <div className="">
  <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><img src={ME} className="w-[170px]  object-contain" alt="" /></div>
  <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-6 text-center">Main Engine</h1>
  
</div>      {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
    <li>Piston Rings & Liners</li>
  <li>Fuel Injection Systems</li>
  <li>Crankshaft & Bearings</li>
    </ul>

    <div className="m-auto flex justify-center">
      <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center mt-10">
        View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right"></i>
      </button>
    </div> */}
  </div>
</Link>

{/* Generator */}
<Link to={'/Gen'} className="generator 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all rounded w-[265px] p-2 h-[200px]">
  <div className="">
  <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><img src={gen} className="w-[170px]  object-contain" alt="" /></div>
  <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-8 text-center">Generator</h1>
  
</div>      {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
    <li>Generator Rotor & Stator</li>
  <li>AVR (Automatic Voltage Regulator)</li>
  <li>Control Panel Components</li>
    </ul>

    <div className="m-auto flex justify-center">
      <button className="rounded border transition-all hover:bg-[#2e5575] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center mt-10">
        View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right"></i>
      </button>
    </div> */}
  </div>
</Link>

{/* Lubs */}
<Link to={'/lube'} className="Lubs 3xl:w-[175px] lg:w-[265px]   bg-white 3xl:m-auto rounded cursor-pointer hover:bg-gray-100 hover:scale-105 transition-all w-[265px] p-3 h-[200px]">
  <div className="">
  <div className="bg-gray-300 w-24 m-auto mt-2 rounded-full"><img src={lube} className="w-[170px]  object-contain" alt="" /></div>
  <div className="bg-[#2e5575] m-auto  rounded-lg ">
          <h1 className="text-white  font-bold text-xl 3xl:text-[13px] py-2 mt-8 text-center">Lube Oil</h1>
  
</div>      {/* <ul className="mt-10 space-y-4 text-center text-[#301D44] text-sm">
    <li>Main Engine Lube Oil</li>
  <li>Hydraulic Oil</li>
  <li>Turbine Oil</li>
    </ul>

    <div className="m-auto flex justify-center">
      <button className="rounded border transition-all hover:bg-[#D1A460] hover:text-[#301D44] border-[#D1A460] text-[#D1A460] p-3 text-center mt-10">
        View Products <i className="fa-solid ms-2 mt-1 fa-arrow-right"></i>
      </button>
    </div> */}
  </div>
</Link>

  </div>
</section>


        {/* Go to Top Button */}
        <NewFooter />
      </div>
    </div>
  );
}
